import Setting from '../setting';
import Storage from './storage';

// 覆盖api请求
let apiMod = {};

//
let isDebug = true;

// 错误拦截
let errorFilterMatch = [];
let errorFilterMatchUnique = {};

//
function getApiMod(url) {
    return apiMod[url] ? apiMod[url] : null;
}

//
function setApiMod(url0, url1) {
    apiMod[url0] = url1;
    return url1;
}

// 参考 https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
class GqlError extends Error {
    constructor(raw = '', ...params) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GqlError);
        }

        // Custom debugging information
        this.name = 'GqlError';
        this.raw = raw;
        if (raw && raw.indexOf('|') > -1) {
            let _raw = raw;
            if (raw.indexOf(' : ') === 0) _raw = raw.split(' : ')[1];
            const atts = _raw.split('|');
            this.code = atts[0];
            this.message = atts.slice(1).join('|');
        } else {
            this.message = raw;
        }
        if (params && params.length > 0) {
            this.action = params[0];
        }
    }
}

// true: 是token错误
const isCodeTokenError = code => {
    switch (code) {
        case 'rest215': // ErrTokenExpired 身份令牌已过期
        case 'rest136': // ErrSessionExpired 会话已过期
        case 'rest81': // ErrTokenChangeLogout token状态改变
        case 'rest79': // ErrTokenChangePassword token密码改变
        case 'rest78': // ErrTokenClaimsInvalid token.Claims无法解析出
        case 'rest77': // ErrTokenInvalid token.valid为false
        case 'rest76': // ErrTokenParseSignMethodNotSupport 不支持的解析方法
        case 'rest75': // ErrTokenParseTypeNotSupport 不支持的解析类型
        case 'rest44': // ErrTokenUndefined token未定义
        case 'user135': // 账号已在重新登陆
        case 'crypto/rsa: verification error': // crypto/rsa: verification error
            // console.log('%c ** 登录信息已过期 00 **> ', 'color: blue;');
            return true;
        default:
            return false;
    }
};

// true: 是网络错误
const isCodeNetworkError = code => {
    if (typeof code === 'string' && code.length >= 2 && code.slice(0, 2) === 'nw') {
        return true;
    } else {
        return false;
    }
};

/**
 * 分离请求 gql 的名称
 * @param gqlString
 * @returns {string}
 */
const handleQueryName = gqlString => {
    let queryName = '';
    if (gqlString.indexOf('query ') > -1) {
        queryName = gqlString.match(/query (\S*)/g)[0].replace('query ', '');
    }
    if (gqlString.indexOf('mutation ') > -1) {
        queryName = gqlString.match(/mutation (\S*)/g)[0].replace('mutation ', '');
    }
    const extraStr = queryName.match(/\((.+)/g);
    let replaceKey = '';
    if (extraStr) {
        replaceKey = extraStr.toString();
        queryName = queryName.replace(replaceKey, '');
    }
    return queryName;
};

// 标准化列表请求
const formQuery = (input, qTag = 'query') => {
    const ret = Object.assign({}, input);
    const query = ret[qTag] ? ret[qTag] : ret;
    //
    if (!query.limit) {
        query.limit = 10; // 默认请求10条
    }
    if (query.key) {
        if (query.keyJson) {
            delete query.key;
        } else {
            if (typeof query.key === 'string') {
                query.keyJson = query.key;
            } else {
                query.keyJson = JSON.stringify(query.key);
            }
            delete query.key;
        }
    }
    if (query.keyJson && query.keyJson === '{}') {
        delete query.keyJson;
    }
    // 容错:参数传错了位置,尝试补救
    if (ret === query) {
        const fix = {};
        fix[qTag] = ret;
        return fix;
    }
    return ret;
};

// 解析错误
function getErrorMsg(err) {
    let ret = {
        title: '',
        message: '',
        code: '',
    };
    if (err) {
        //
        if (!ret.title && err.action) {
            ret.title = err.action;
        }
        if (!ret.title && err.title) {
            ret.title = err.title;
        }
        //
        if (!ret.message && err.errMsg) {
            ret.message = err.errMsg;
        }
        if (!ret.message && err.message) {
            ret.message = err.message;
        }
        //
        if (err.code) {
            ret.code = err.code;
        }
    }
    //
    if (!ret.title) {
        ret.title = 'error';
    }
    if (!ret.message) {
        ret.message = 'unknown';
    }
    return ret;
}

//
let fetchJson = (url = '', method = 'POST', headers = {}, data = '') => {
    return new Promise((resolve, reject) => {
        console.warn('fetchJson undefined');
        setTimeout(function () {
            reject('undefined');
        }, 10);
    });
};

//
function hookFetchJson(f) {
    fetchJson = f;
}

// 内部错误处理
let defaultErrorHandler = err => {
    console.error('err', err);
};

//
function hookErrorHandler(f) {
    defaultErrorHandler = f;
}

// 添加hook isPrepend:添加到优先执行 fn:返回true则不处理错误
function addErrorFilter(fn, isPrepend = false) {
    if (fn && {}.toString.call(fn) === '[object Function]' && !errorFilterMatchUnique[fn]) {
        errorFilterMatchUnique[fn] = 1;
        const wrapper = err => {
            const info = getErrorMsg(err);
            const res = fn(info);
            if (res === undefined || res === null) {
                return false;
            } else {
                return !!res;
            }
        };
        if (isPrepend === true) {
            errorFilterMatch.unshift(wrapper);
        } else {
            errorFilterMatch.push(wrapper);
        }
    }
}

// 拦截错误
function doErrorFilter(err) {
    for (let i = 0; i < errorFilterMatch.length; i++) {
        if (errorFilterMatch[i](err)) {
            // 有一个错误拦截器认领这个错误,返回
            return true;
        }
    }
    return false;
}

//
function requestGql(query = '', variables = {}, service = '', action = '', errFix = {}) {
    const _headers = {
        Accept: 'application/json;charset=utf-8',
        'Content-Type': 'application/json',
        'Accept-Language': Setting.getLanguage(),
    };
    const _token = Storage.getToken();
    //
    if (_token) {
        _headers.Authorization = `Bearer ${_token}`;
    }
    if (service && service.length > 0) {
        _headers['X-SERVER'] = service;
    }
    // 前端处理gql入口分流
    let apiUrl = Setting.getGqlNetworkInterface();
    let apiModel = 'user'; // 默认请求用户模块
    let apiSuffix = '';
    if (service && service.length > 0) {
        const att = service.split('-');
        if (att[0]) {
            apiModel = att[0];
        }
        if (att.length > 1) {
            apiSuffix = att[1];
        }
    }
    if (apiSuffix.length) {
        apiUrl = apiUrl.replace(/\/graphql$/, `\/${apiModel}\/${apiSuffix}.graphql`);
    } else {
        apiUrl = apiUrl.replace(/\/graphql$/, `\/${apiModel}\/graphql`);
    }
    // 覆盖
    const apiMod = getApiMod(apiUrl);
    if (apiMod) {
        apiUrl = apiMod;
    }
    //
    return fetchJson(
        apiUrl + '?a=' + handleQueryName(query),
        'POST',
        _headers,
        JSON.stringify({
            query,
            variables,
        }),
    )
        .then(responseJson => {
            // 返回json
            let ret = responseJson;
            if (responseJson && responseJson.errors && responseJson.errors.length > 0) {
                // 接口报错,返回null或抛出error
                ret = null;
                // 错误解析
                // console.log('** responseJson.errors **> ', responseJson.errors);
                let err = new GqlError(responseJson.errors[0].message, action);
                // 错误覆盖
                if (errFix) {
                    switch (typeof errFix) {
                        case 'function':
                            const _err = errFix(err);
                            if (_err === false) {
                                // 终止传播
                                return;
                            } else if (_err) {
                                // 覆盖错误
                                switch (typeof _err) {
                                    case 'string':
                                        err.message = _err;
                                        break;
                                    case 'object':
                                        err = _err;
                                        break;
                                    default:
                                        break;
                                }
                            }
                            break;
                        case 'object':
                            if (err.code && errFix[err.code]) {
                                // code匹配覆盖
                                err.message = errFix[err.code];
                            } else if (errFix['']) {
                                // 缺省覆盖
                                err.message = errFix[''];
                            }
                            break;
                        case 'string':
                            err.message = errFix;
                            break;
                        default:
                            break;
                    }
                }
                // 错误讨论
                if (isCodeTokenError(err.code)) {
                    // token错误:储存出错的位置
                    if (window && window.location && window.location.hash) {
                        Storage.setValue(Setting.getStoreUrl(), window.location.hash.split('#')[1]);
                    }
                    if (Setting.errorHandlerToken && {}.toString.call(Setting.errorHandlerToken) === '[object Function]') {
                        Setting.errorHandlerToken(err);
                        // 终止错误传播
                    } else {
                        defaultErrorHandler(err);
                        throw err;
                    }
                } else {
                    // 接口错误
                    if (Setting.errorHandler && {}.toString.call(Setting.errorHandler) === '[object Function]') {
                        // 自定义错误处理
                        Setting.errorHandler(err);
                    } else {
                        // 缺省错误处理
                        defaultErrorHandler(err);
                    }
                    // 抛错以终止逻辑
                    throw err;
                }
            }
            //
            if (ret && ret.data) {
                ret = ret.data;
            }
            if (isDebug === true) {
                console.log(`[gql]`, { action, variables }, ret);
            }
            return ret;
        })
        .catch(err => {
            console.log('[network-err]', err);
            err.action = action;
            if (err.errMsg) {
                // 网络错误
                err.code = 'nw1';
                err.errMsg = `请检查网络稍后再试：${err.errMsg}`;
            }
            if (Setting.errorHandler && {}.toString.call(Setting.errorHandler) === '[object Function]') {
                // 自定义错误处理
                Setting.errorHandler(err);
            } else {
                // 缺省错误处理
                defaultErrorHandler(err);
            }
            // 抛错以终止逻辑
            throw err;
        });
}

//
export default {
    GqlError,
    isCodeTokenError,
    isCodeNetworkError,
    handleQueryName,
    formQuery,
    getErrorMsg,
    addErrorFilter,
    doErrorFilter,
    fetchJson,
    hookFetchJson,
    hookErrorHandler,
    requestGql,
    isDebug,
    getApiMod,
    setApiMod,
};
